fabric.SVGObject = fabric.util.createClass(fabric.Object, {
    type: 'svg-object',

    svgString: '',
    svgColor: '',
    svgImage: null,
    coverMaskArea: false,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('svgString', 'svgImage', 'svgColor'),

    _svgDoc: null,
    _svgHeight: 1,
    _svgWidth: 1,
    _colorFilter: null,

    // This is only intended for TESTING
    _renderPromise: null,

    initialize: function (options) {
        this.callSuper('initialize', options);
        this._colorFilter = new fabric.Image.filters.BlendColor({
            color: this.svgColor,
            mode: 'tint',
            alpha: 1
        });
    },

    _loadImage: function (src) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onerror = function () {
                reject();
            };
            image.onload = function () {
                resolve(image);
            };
            image.src = src;
        });
    },

    _loadSvgString: function (svgString) {
        const scope = this;
        return new Promise(async (resolve, reject) => {
            try {
                if (svgString) {
                    // Load SVG into an image
                    let svgImage = await this._loadImage('data:image/svg+xml,' + encodeURIComponent(svgString));

                    // We need to attach the Image to the DOM temporarily so we can read its size on IE
                    svgImage.style.opacity = 0;
                    svgImage.style.position = 'fixed';
                    document.body.appendChild(svgImage);

                    // Save SVG width and height.
                    scope._svgHeight = svgImage.naturalHeight;
                    scope._svgWidth = svgImage.naturalWidth;
                    document.body.removeChild(svgImage);

                    // On IE, naturalWidth and naturalHeight are 0 so try parsing the SVG string
                    //  and see if it has width and height attributes.
                    // Also, for the SVG to be properly rendered we need to add SVG width and height attributes in case
                    //  they are missing.
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(svgString, 'image/svg+xml');
                    const element = doc.getElementsByTagName('svg')[0];
                    scope._svgDoc = doc;

                    if (doc && element) {
                        // Try getting the SVG dimensions from the width/height attributes
                        let w = element.getAttribute('width');
                        let h = element.getAttribute('height');

                        // If the svg doesn't have width and height parameters it won't be rendered with the correct size on the canvas
                        //  so extract the width/height parameters from the view box and set them as SVG width/height attributes
                        if (!w || !h) {
                            const viewBox = element.viewBox.baseVal;
                            if (viewBox.width && viewBox.height) {
                                w = viewBox.width;
                                h = viewBox.height;
                                element.setAttribute('width', viewBox.width + 'px');
                                element.setAttribute('height', viewBox.height + 'px');
                                scope._svgWidth = w;
                                scope._svgHeight = h;

                                // Build the new image with the correct attributes
                                svgImage = await this._loadImage(
                                    'data:image/svg+xml,' +
                                        encodeURIComponent(new XMLSerializer().serializeToString(doc))
                                );
                            }
                        }

                        // This regex checks if we have any non valid characters in the width (we need the dimensions
                        //  to only have 'px' or no unit at all). Use the dimensions given by the width and height attributes
                        //  if we couldn't get them from naturalWidth and naturalHeight BUT only if width and height attributes
                        //  exists because we need no add them otherwise.
                        const regex = /[^\d.px]/;
                        if (w && h && !regex.test(w) && !regex.test(h)) {
                            if (scope._svgHeight === 0 && scope._svgWidth === 0) {
                                scope._svgWidth = parseFloat(w);
                                scope._svgHeight = parseFloat(h);
                            }
                        } else {
                            // When no width/height is in the SVG and it's drawn on the canvas, on Chrome it fits the entire canvas size where it's drawn but
                            //  on Firefox it just won't render so we need to add the width and height params to the SVG using the canvas size.
                            scope._svgWidth = null;
                            scope._svgHeight = null;
                        }
                    } else {
                        console.error('Error parsing SVG');
                        scope._svgWidth = null;
                        scope._svgHeight = null;
                    }

                    scope.svgImage = svgImage;
                    scope.set('dirty', true);

                    // Apply scaling for cover if needed
                    scope._applyCoverScale();

                    // Now that the image is loaded, render the canvas
                    if (scope.canvas) {
                        scope.canvas.renderAll();
                    }
                    resolve();
                } else {
                    // Don't draw anything
                    this.set('svgImage', null);
                    this.set('_svgDoc', null);
                    resolve();
                }
            } catch (err) {
                console.error(err);
                reject(err);
            }
        });
    },

    _set: function (key, value) {
        if (key === 'svgString') {
            this._renderPromise = this._loadSvgString(value);
        } else if (key === 'svgImage') {
            if (value) {
                this._svgWidth = value.width;
                this._svgHeight = value.height;
            }
        } else if (key === 'svgColor') {
            this.callSuper('_set', key, value);
            var alpha = new fabric.Color(this.svgColor).getAlpha();
            this.opacity = alpha;
        }

        this.callSuper('_set', key, value);
    },

    _getSvgScalingToFit: function () {
        let scale = 1;
        const w = this.width,
            h = this.height;

        if (this._svgHeight > this._svgWidth) {
            scale = h / this._svgHeight;

            if (this._svgWidth * scale > w) {
                scale = w / this._svgWidth;
            }
        } else {
            scale = w / this._svgWidth;

            if (this._svgHeight * scale > h) {
                scale = h / this._svgHeight;
            }
        }

        return scale;
    },

    _applyCoverScale: function () {
        if (this.coverMaskArea && this._svgWidth && this._svgHeight) {
            const svgScale = this._getSvgScalingToFit();

            const scaleX = this.width / (this._svgWidth * svgScale);
            const scaleY = this.height / (this._svgHeight * svgScale);
            const scale = Math.max(scaleX, scaleY);

            this.set('scaleX', scale);
            this.set('scaleY', scale);
        }
    },

    /**
     * @param {CanvasRenderingContext2D} ctx
     */
    _render: function (ctx) {
        if (this.svgImage) {
            // Set the SVG width and height attributes if needed
            if (this._svgDoc && this._svgHeight === null && this._svgWidth === null) {
                // Add the width and height attributes using the current canvas size
                const element = this._svgDoc.getElementsByTagName('svg')[0];
                element.setAttribute('width', ctx.canvas.width + 'px');
                element.setAttribute('height', ctx.canvas.height + 'px');

                this._svgWidth = ctx.canvas.width;
                this._svgHeight = ctx.canvas.height;

                // Get the SVG string with the width and height attributes and reload it
                var svgString = new XMLSerializer().serializeToString(this._svgDoc);
                this.set('svgString', svgString);
                return;
            }

            // Scale the SVG to fit into the object but keep the aspect ratio
            const scale = this._getSvgScalingToFit();

            // Center the SVG
            var x = -(this._svgWidth * scale) / 2,
                y = -(this._svgHeight * scale) / 2;
            ctx.translate(x, y);

            // Draw the scaled SVG
            ctx.scale(scale, scale);
            ctx.drawImage(this.svgImage, 0, 0);

            // Apply the color filter if necessary
            if (this.svgColor) {
                this._colorFilter.color = this.svgColor;

                var imgData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
                this._colorFilter.applyTo2d({
                    imageData: imgData
                });
                ctx.putImageData(imgData, 0, 0);
            }
        }
    }
});
